import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

export const authGuard: CanActivateFn = () => {
  const oauthService: OAuthService = inject(OAuthService);

  if (!oauthService.hasValidAccessToken()) {
    oauthService.loadDiscoveryDocumentAndLogin().then();
    return false;
  }

  return true;
};

export const authGuardChild: CanActivateChildFn = () => {
  const oauthService: OAuthService = inject(OAuthService);

  if (!oauthService.hasValidAccessToken()) {
    oauthService.loadDiscoveryDocumentAndLogin().then();
    return false;
  }

  return true;
};
